export class RolBasic {

    private centerInternalId: string;
    private centerName: string;
    private internalId: string;
    private roleInternalId: string;
    private roleName: string;

    constructor(centerInternalId?: string, centerName?: string, internalId?: string, roleInternalId?: string, roleName?: string) {
        this.centerInternalId = centerInternalId;
        this.centerName = centerName;
        this.internalId = internalId;
        this.roleInternalId = roleInternalId;
        this.roleName = roleName;
    }

    public get CenterInternalId() {
        return this.centerInternalId;
    }
    public get CenterName() {
        return this.centerName;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get RoleInternalId() {
        return this.roleInternalId;
    }
    public get RoleName() {
        return this.roleName;
    }

    public set CenterInternalId(centerInternalId) {
        this.centerInternalId = centerInternalId;
    }
    public set CenterName(centerName) {
        this.centerName = centerName;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set RoleInternalId(roleInternalId) {
        this.roleInternalId = roleInternalId;
    }
    public set RoleName(roleName) {
        this.roleName = roleName;
    }
}
